import { render, staticRenderFns } from "./HeaderBar.vue?vue&type=template&id=0a6d8775&scoped=true"
var script = {}
import style0 from "./HeaderBar.vue?vue&type=style&index=0&id=0a6d8775&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6d8775",
  null
  
)

export default component.exports